import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { socialBarDriverFactory } from './SocialBar.driver';
import {
  SocialBarExample,
  SocialBarPopulatedExample,
} from './SocialBarExamples';
import { SocialBar } from './SocialBar';
import { SocialBarIconTestHook } from './consts';

describe('SocialBar', () => {
  const createDriver = createRendererWithUniDriver(socialBarDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<SocialBar />);
    expect(await driver.exists()).toBe(true);
  });
  it('should render one child', async () => {
    const { driver } = createDriver(<SocialBarExample />);
    expect(await driver.childrenCount(SocialBarIconTestHook)).toBe(1);
  });
  it('should render array of children', async () => {
    const { driver } = createDriver(<SocialBarPopulatedExample />);
    expect(await driver.childrenCount(SocialBarIconTestHook)).toBeGreaterThan(
      1,
    );
  });
  it('should not have type button', async () => {
    const { driver } = createDriver(<SocialBarExample />);
    expect((await driver.element()).innerHTML).not.toContain('type="button"');
  });
});
